<mat-toolbar>
  <fa-icon icon="{{ IconName }}" id="icon" class="fa-lg" matTooltipPosition="above"></fa-icon>
  &nbsp;<div class="client-title">{{ ClientTitle }}</div>
</mat-toolbar>
